/**
 * Left-pad a non-negative integer to at least two digits.
 * @param {number} n
 * @returns {string}
 */
export const pad2 = (n) => String(n).padStart(2, '0');

/**
 * Break a duration in milliseconds into display components.
 *
 * The value is clamped to zero (a stopwatch never shows negative time) and
 * floored to whole milliseconds so callers never have to deal with sub-ms
 * float noise. Unlike the previous implementation there is no 60-minute wrap:
 * hours accumulate for as long as the stopwatch runs.
 *
 * @param {number} ms - elapsed milliseconds
 * @returns {{ hours: number, minutes: number, seconds: number, tenths: number }}
 */
export function formatDuration(ms) {
  const safe = Number.isFinite(ms) ? Math.max(0, Math.floor(ms)) : 0;
  const totalSeconds = Math.floor(safe / 1000);

  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    tenths: Math.floor((safe % 1000) / 100),
  };
}
